import React from 'react';
import { CalendarCheckIcon, FileSignatureIcon, MicIcon, NotebookPenIcon, UserPlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { VignetteFrame } from './VignetteFrame';
const entries: {
  icon: 'contact' | 'call' | 'note' | 'appointment' | 'signature';
  title: string;
  detail: string;
  time: string;
}[] = [{
  icon: 'contact',
  title: 'Contact created',
  detail: 'Sam T. | Source: Zillow lead line',
  time: '9:42 PM'
}, {
  icon: 'call',
  title: 'Call logged',
  detail: 'Inbound, 2m 41s. Recording and transcript attached.',
  time: '9:45 PM'
}, {
  icon: 'note',
  title: 'Qualification note',
  detail: 'Buyer, $600k to $750k, pre-approved, East Cactus, Saturday preferred.',
  time: '9:45 PM'
}, {
  icon: 'appointment',
  title: 'Appointment booked',
  detail: 'Buyer tour, Saturday 10:00 AM, assigned to Jordan.',
  time: '9:46 PM'
}, {
  icon: 'signature',
  title: 'Agreement signed',
  detail: 'Buyer Touring Agreement, e-signed and filed.',
  time: '9:24 AM'
}];
const icons = {
  contact: UserPlusIcon,
  call: MicIcon,
  note: NotebookPenIcon,
  appointment: CalendarCheckIcon,
  signature: FileSignatureIcon
};
export function CrmVignette() {
  return <VignetteFrame label="CRM activity" timestamp="Sam T." data-id="element-278" data-mp="2yf3hhao8ykab">
      <Reveal className="flex items-center justify-between gap-4 rounded-xl border border-white/10 bg-ink-700 px-4 py-3" data-id="element-279" data-mp="2ydk2roi8ohan">
        <div data-id="element-280" data-mp="2joe544z1uz4v">
          <p className="text-sm font-semibold text-white" data-id="element-281" data-mp="2ogxj331nfwa7">Sam T.</p>
          <p className="mt-0.5 text-xs text-white/45" data-id="element-282" data-mp="2oi8nn52x582d">Source: Zillow lead line</p>
        </div>
        <span className="rounded-full border border-brand/30 bg-brand/10 px-3 py-1 text-xs font-medium text-brand" data-id="element-283" data-mp="2ardl0aj0jn78">
          New lead
        </span>
      </Reveal>

      <ol className="mt-5 space-y-3" data-id="element-284" data-mp="20r370np5mbr0">
        {entries.map((entry, index) => {
        const Icon = icons[entry.icon];
        return <li key={entry.title} data-id="element-285" data-mp="25siroenf6g8v" data-mpi={index}>
              <Reveal delay={0.15 + index * 0.14} offset={8} className="flex items-start gap-3 border-l border-white/10 pl-4" data-id="element-286" data-mp="b9zcp9buh6sb">
                <span className="mt-0.5 flex h-7 w-7 flex-none items-center justify-center rounded-lg border border-white/10 bg-ink-700" data-id="element-287" data-mp="2hnwshecx1ql">
                  <Icon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-288" data-mp="3tpi7hlaipfaq" />
                </span>
                <div className="min-w-0" data-id="element-289" data-mp="u7seg8aqfao4">
                  <div className="flex flex-wrap items-baseline gap-x-3" data-id="element-290" data-mp="u6qxxoay5vz0">
                    <p className="text-sm font-semibold text-white" data-id="element-291" data-mp="q89qt4rj0lhl">{entry.title}</p>
                    <span className="text-[11px] tabular-nums text-white/35" data-id="element-292" data-mp="l6u6jex6aj09">
                      {entry.time}
                    </span>
                  </div>
                  <p className="mt-1 text-xs leading-relaxed text-white/55" data-id="element-293" data-mp="35z5sjqguuian">
                    {entry.detail}
                  </p>
                </div>
              </Reveal>
            </li>;
      })}
      </ol>
    </VignetteFrame>;
}